require('./ui/common.js');
require('./ui/swiper_init.js');
require('./ui/ajax-forms.js');
require('./ui/popup.js');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js